module.exports = __webpack_public_path__ + "img/photo-0033.a858c0b7.jpg";